import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

export default function AppNoIndexLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/app')) {
      document
        .querySelectorAll('meta[property^="og:"],meta[name^="twitter:"]')
        .forEach(el => el.remove());
    }
  }, [pathname]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,follow" />
        <meta name="googlebot" content="noindex,follow" />
      </Helmet>
      <Outlet />
    </>
  );
}